import { AbstractControl, ValidationErrors } from '@angular/forms';

const countries: { countryCode: string, ibanLength: number }[] = [
    {countryCode: 'AD', ibanLength: 24},
    {countryCode: 'AE', ibanLength: 23},
    {countryCode: 'AL', ibanLength: 28},
    {countryCode: 'AT', ibanLength: 20},
    {countryCode: 'AZ', ibanLength: 28},
    {countryCode: 'BA', ibanLength: 20},
    {countryCode: 'BE', ibanLength: 16},
    {countryCode: 'BG', ibanLength: 22},
    {countryCode: 'BH', ibanLength: 22},
    {countryCode: 'BR', ibanLength: 29},
    {countryCode: 'BY', ibanLength: 28},
    {countryCode: 'CG', ibanLength: 27},
    {countryCode: 'CH', ibanLength: 21},
    {countryCode: 'CR', ibanLength: 22},
    {countryCode: 'CY', ibanLength: 28},
    {countryCode: 'CZ', ibanLength: 24},
    {countryCode: 'DE', ibanLength: 22},
    {countryCode: 'DK', ibanLength: 18},
    {countryCode: 'DO', ibanLength: 28},
    {countryCode: 'EE', ibanLength: 20},
    {countryCode: 'EG', ibanLength: 27},
    {countryCode: 'ES', ibanLength: 24},
    {countryCode: 'FI', ibanLength: 18},
    {countryCode: 'FO', ibanLength: 18},
    {countryCode: 'FR', ibanLength: 27},
    {countryCode: 'GA', ibanLength: 27},
    {countryCode: 'GB', ibanLength: 22},
    {countryCode: 'GE', ibanLength: 22},
    {countryCode: 'GI', ibanLength: 23},
    {countryCode: 'GL', ibanLength: 18},
    {countryCode: 'GR', ibanLength: 27},
    {countryCode: 'GT', ibanLength: 28},
    {countryCode: 'HN', ibanLength: 28},
    {countryCode: 'HR', ibanLength: 21},
    {countryCode: 'HU', ibanLength: 28},
    {countryCode: 'IE', ibanLength: 22},
    {countryCode: 'IL', ibanLength: 23},
    {countryCode: 'IQ', ibanLength: 23},
    {countryCode: 'IS', ibanLength: 26},
    {countryCode: 'IT', ibanLength: 27},
    {countryCode: 'JO', ibanLength: 30},
    {countryCode: 'KM', ibanLength: 27},
    {countryCode: 'KW', ibanLength: 30},
    {countryCode: 'KZ', ibanLength: 20},
    {countryCode: 'LB', ibanLength: 28},
    {countryCode: 'LC', ibanLength: 32},
    {countryCode: 'LI', ibanLength: 21},
    {countryCode: 'LT', ibanLength: 20},
    {countryCode: 'LU', ibanLength: 20},
    {countryCode: 'LV', ibanLength: 21},
    {countryCode: 'MA', ibanLength: 28},
    {countryCode: 'MC', ibanLength: 27},
    {countryCode: 'MD', ibanLength: 24},
    {countryCode: 'ME', ibanLength: 22},
    {countryCode: 'MK', ibanLength: 19},
    {countryCode: 'MR', ibanLength: 27},
    {countryCode: 'MT', ibanLength: 31},
    {countryCode: 'MU', ibanLength: 30},
    {countryCode: 'NE', ibanLength: 28},
    {countryCode: 'NI', ibanLength: 32},
    {countryCode: 'NL', ibanLength: 18},
    {countryCode: 'NO', ibanLength: 15},
    {countryCode: 'PK', ibanLength: 24},
    {countryCode: 'PL', ibanLength: 28},
    {countryCode: 'PS', ibanLength: 29},
    {countryCode: 'PT', ibanLength: 25},
    {countryCode: 'QA', ibanLength: 29},
    {countryCode: 'RO', ibanLength: 24},
    {countryCode: 'RS', ibanLength: 22},
    {countryCode: 'SA', ibanLength: 24},
    {countryCode: 'SC', ibanLength: 31},
    {countryCode: 'SE', ibanLength: 24},
    {countryCode: 'SI', ibanLength: 19},
    {countryCode: 'SK', ibanLength: 24},
    {countryCode: 'SM', ibanLength: 27},
    {countryCode: 'TL', ibanLength: 23},
    {countryCode: 'TN', ibanLength: 24},
    {countryCode: 'TR', ibanLength: 26},
    {countryCode: 'UA', ibanLength: 29},
    {countryCode: 'VA', ibanLength: 22},
    {countryCode: 'VG', ibanLength: 24},
    {countryCode: 'DZ', ibanLength: 24},
    {countryCode: 'AO', ibanLength: 25},
    {countryCode: 'BJ', ibanLength: 28},
    {countryCode: 'BF', ibanLength: 28},
    {countryCode: 'BI', ibanLength: 16},
    {countryCode: 'CM', ibanLength: 27},
    {countryCode: 'CV', ibanLength: 25},
    {countryCode: 'IR', ibanLength: 26},
    {countryCode: 'CI', ibanLength: 28},
    {countryCode: 'MG', ibanLength: 27},
    {countryCode: 'ML', ibanLength: 28},
    {countryCode: 'MZ', ibanLength: 25},
    {countryCode: 'SN', ibanLength: 28},
    {countryCode: 'TD', ibanLength: 27},
    {countryCode: 'TG', ibanLength: 28},
    {countryCode: 'XK', ibanLength: 20}
];

function trimIBAN(inputStr: string) {
    return (inputStr || '').replace(/\s/g, '').trim();
}

/**
 * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
 * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
 */
function iso13616Prepare(iban: string): string {
    iban = iban.toUpperCase();
    iban = iban.substr(4) + iban.substr(0, 4);

    return iban
        .split('')
        .map(char => parseInt(char, 36))
        .join('');
}

/**
 * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
 */
function iso7064Mod97_10(iban: string): number {
    let remainder = iban;
    let block;

    while (remainder.length > 2) {
        block = remainder.slice(0, 9);
        remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
    }

    return parseInt(remainder, 10) % 97;
}

export class IbanValidator {

    /**
     * Performs multiples check on the country code :
     * - Required length of 2
     * - Contains only 2 alphabet chars
     * - The country code exists
     */
    static countryCode(control: AbstractControl): ValidationErrors | null {
        if (!control?.value) {
            return null;
        }

        const countryCode = trimIBAN(control.value).substr(0, 2);

        return IbanValidator.validateCountryCode(countryCode);
    }

    /**
     * Performs multiples check on the control key :
     * - Required length of 2
     * - Is a number
     * - Should be between 02 and 98
     * @see https://fr.wikipedia.org/wiki/International_Bank_Account_Number
     */
    static controlKey(control: AbstractControl): ValidationErrors | null {
        if (!control?.value) {
            return null;
        }

        let controlKey = trimIBAN(control.value).substr(0, 4);

        // if out string starts with 2 alphabetical chars, we should substring to have the 2 numbers
        // EG : FRXX
        if (/[a-zA-Z]{2}/.test(controlKey)) {
            controlKey = controlKey.substr(2, 2);
        }

        return IbanValidator.validateControlKey(controlKey);
    }

    /**
     * Performs multiples check on IBAN :
     * - Length
     * - Validity using MOD 97
     */
    static iban(control: AbstractControl): ValidationErrors | null {
        const iban = trimIBAN(control.value);
        if (!iban) {
            return null;
        }

        const countryCode = iban.substr(0, 2);
        const countryCodeValidation = IbanValidator.validateCountryCode(countryCode);
        if (!!countryCodeValidation) {
            return countryCodeValidation;
        }

        const controlKey = iban.substr(2, 2);
        const controlKeyValidation = IbanValidator.validateControlKey(controlKey);
        if (!!controlKeyValidation) {
            return controlKeyValidation;
        }

        // arrivé à ce stade, l'IBAN correspond obligatoirement à un pays existant
        // Sinon, on a déjà exit la fonction avec countryCodeValidation
        const countryIbanLength = countries.find(c =>
            c.countryCode === countryCode.toLocaleUpperCase()
        ).ibanLength;

        if (iban.length !== countryIbanLength) {
            return {ibanrequiredlength: {requiredlength: countryIbanLength}};
        } else if (iso7064Mod97_10(iso13616Prepare(iban)) !== 1) {
            return {invalidiban: true};
        }

        return null;
    }

    private static validateCountryCode(countryCode: string): ValidationErrors | null {
        if (countryCode.length !== 2) {
            // check length
            return {countrycodelength: true};
        } else if (!/[a-zA-Z]{2}/.test(countryCode)) {
            // check if our string contains 2 alphabet chars
            return {countrycodebadchars: true};
        } else if (countries.every(c => c.countryCode !== countryCode.toLocaleUpperCase())) {
            // check if the country code is valid
            return {invalidcountrycode: true};
        } else {
            return null;
        }
    }

    private static validateControlKey(controlKey: string): ValidationErrors | null {
        if (controlKey.length !== 2) {
            // check if we have the correct length
            return {controlkeylength: true};
        } else if (isNaN(+controlKey)) {
            // check if we have numbers
            return {controlkeynotanumber: true};
        } else if (+controlKey < 2 || +controlKey > 98) {
            // check if we are between 02 and 98
            return {controlkeynotinrange: true};
        } else {
            return null;
        }
    }

}
